if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
}
window.scrollTo(0, 0);
$(function () {
    window.scrollTo(0, 0);

    var homeSwiperEl = document.querySelector('.home-sections-swiper');

    var isDesktopViewport = window.matchMedia('(min-width: 992px)').matches;

    if (homeSwiperEl && window.Swiper && isDesktopViewport) {
        var homeSwiper = new window.Swiper(homeSwiperEl, {
            direction: 'vertical',
            modules: [window.SwiperModules.Mousewheel, window.SwiperModules.Keyboard],
            speed: 700,
            mousewheel: {
                enabled: true,
                thresholdTime: 700,
                thresholdDelta: 10,
                releaseOnEdges: true
            },
            keyboard: {
                enabled: true
            }
        });

        homeSwiper.slideTo(0, 0);

        function formatStatistic(value) {
            if (value < 1000) {
                return Math.round(value).toString();
            }

            var number;
            var suffix;

            if (value < 1000000) {
                number = value / 1000;
                suffix = 'K';
            } else {
                number = value / 1000000;
                suffix = 'M';
            }

            if (number >= 100) {
                return Math.round(number) + ' ' + suffix;
            }

            return number.toFixed(1).replace(/\.0$/, '') + ' ' + suffix;
        }

        function animateStats($scope) {
            $scope.find('.stat-value').each(function () {
                var $el = $(this);
                var target = parseFloat($el.data('stat-value'));

                if (isNaN(target)) {
                    return;
                }

                var duration = 2500;
                var startTime = null;

                function step(timestamp) {
                    if (!startTime) {
                        startTime = timestamp;
                    }

                    var progress = Math.min((timestamp - startTime) / duration, 1);
                    var eased = 1 - Math.pow(1 - progress, 3);

                    $el.text(formatStatistic(target * eased));

                    if (progress < 1) {
                        requestAnimationFrame(step);
                    } else {
                        $el.text(formatStatistic(target));
                    }
                }

                requestAnimationFrame(step);
            });
        }

        var $body = $('body');
        $body.addClass('home-scroll-locked');

        function scheduleUnlockAtEnd() {
            if (!homeSwiper.isEnd) {
                return;
            }

            setTimeout(function () {
                if (homeSwiper.isEnd) {
                    $body.removeClass('home-scroll-locked');
                    homeSwiper.mousewheel.disable();
                }
            }, 500);
        }

        homeSwiper.on('slideChangeTransitionEnd', function () {
            var $activeSlide = $(homeSwiper.slides[homeSwiper.activeIndex]);
            var $statsBlock = $activeSlide.find('.stats-block');

            if ($statsBlock.length) {
                animateStats($statsBlock);
            }

            scheduleUnlockAtEnd();
        });

        $('.back-to-top').on('click', function () {
            homeSwiper.mousewheel.enable();
            $body.addClass('home-scroll-locked');

            $('html, body')
                .stop(true)
                .animate(
                    {
                        scrollTop: 0
                    },
                    300,
                    function () {
                        homeSwiper.slideTo(0, 600);
                    }
                );
        });

        $(document).on('wheel', function (e) {
            var deltaY = e.originalEvent.deltaY;
            var bodyLocked = $body.hasClass('home-scroll-locked');

            if (!bodyLocked && window.scrollY > 2) {
                return;
            }

            if (!bodyLocked && window.scrollY <= 2 && deltaY < 0) {
                $body.addClass('home-scroll-locked');
                homeSwiper.mousewheel.enable();
                homeSwiper.slideTo(homeSwiper.slides.length - 1, 0);
            }
        });
    }

    function cloneSlidesToMinimum(swiperEl, minSlides) {
        var wrapper = swiperEl.querySelector('.swiper-wrapper');
        var originals = Array.prototype.slice.call(wrapper.children);

        if (!originals.length) {
            return;
        }

        while (wrapper.children.length < minSlides) {
            originals.forEach(function (slide) {
                var clone = slide.cloneNode(true);
                clone.setAttribute('aria-hidden', 'true');
                wrapper.appendChild(clone);
            });
        }
    }

    document.querySelectorAll('.logo-marquee-track').forEach(function (track) {
        Array.prototype.slice.call(track.children).forEach(function (item) {
            var clone = item.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            clone.querySelector('img').setAttribute('alt', '');
            track.appendChild(clone);
        });
    });

    var systemsSwiperEl = document.querySelector('.systems-swiper');

    if (systemsSwiperEl && window.Swiper) {
        cloneSlidesToMinimum(systemsSwiperEl, 6);
        new window.Swiper(systemsSwiperEl, {
            modules: [window.SwiperModules.Autoplay],
            slidesPerView: 1,
            centeredSlides: false,
            spaceBetween: 16,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            loop: true,
            loopAdditionalSlides: 2,
            speed: 1200,
            autoplay: {
                delay: 4500,
                disableOnInteraction: false
            },
            breakpoints: {
                992: {
                    slidesPerView: 'auto',
                    centeredSlides: true,
                    spaceBetween: 24,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0
                }
            }
        });
    }

    var commentsSwiperEl = document.querySelector('.comments-swiper');

    if (commentsSwiperEl && window.Swiper) {
        cloneSlidesToMinimum(commentsSwiperEl, 6);
        new window.Swiper(commentsSwiperEl, {
            modules: [window.SwiperModules.Autoplay],
            slidesPerView: 1,
            spaceBetween: 24,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            loop: true,
            speed: 900,
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 2
                },
                992: {
                    slidesPerView: 3,
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 0
                }
            }
        });
    }

    function playHeroAnimation($scope) {
        if (!$scope || !$scope.length) {
            return;
        }

        var $els = $scope.find('.hero-subtitle, .hero-cta');

        $els.removeClass('hero-animate-in');
        void $scope.get(0).offsetWidth;

        $els.each(function (index) {
            $(this)
                .css('animation-delay', index * 0.15 + 's')
                .addClass('hero-animate-in');
        });
    }

    var $heroCarousel = $('#heroCarousel');

    if ($heroCarousel.length) {
        playHeroAnimation($heroCarousel.find('.carousel-item.active').first());

        $heroCarousel.on('slid.bs.carousel', function (e) {
            playHeroAnimation($(e.relatedTarget));
        });
    } else {
        playHeroAnimation($('.hero-fallback'));
    }

    var heroRotateWords = ['LMS', 'TMS', 'EBT'];
    var heroRotateIndex = 0;
    var $heroRotateWord = $('.hero-rotate-word');

    if ($heroRotateWord.length) {
        setInterval(function () {
            $heroRotateWord.css('opacity', 0);

            setTimeout(function () {
                heroRotateIndex = (heroRotateIndex + 1) % heroRotateWords.length;
                $heroRotateWord.text(heroRotateWords[heroRotateIndex]).css('opacity', 1);
            }, 300);
        }, 2500);
    }
});
